<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4" style="padding-bottom: 0 !important">
      <div class="mb-3 mb-lg-4">
        <h3 class="mb-0">Requisition Overview</h3>
      </div>
      <div class="row">
        <div class="col-xxl-6 col-xl-6 col-sm-6">
          <div
            class="card bg-primary bg-opacity-10 border-primary-div border-opacity-10 rounded-3 mb-4 stats-box style-three"
          >
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-19">
                <div class="flex-shrink-0">
                  <i class="material-symbols-outlined fs-40 text-primary">
                    draft
                  </i>
                </div>
                <div class="flex-grow-1 ms-2">
                  <span>Draft</span>
                  <h3 class="fs-20 mt-1 mb-0">{{ reqOverview?.draft }}</h3>
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-items-center"
              >
                <span class="fs-12">Requisition Status Draft</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-6 col-xl-6 col-sm-6">
          <div
            class="card bg-danger bg-opacity-10 border-danger border-opacity-10 rounded-3 mb-4 stats-box style-three"
          >
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-19">
                <div class="flex-shrink-0">
                  <i class="material-symbols-outlined fs-40 text-danger">
                    hourglass_bottom
                  </i>
                </div>
                <div class="flex-grow-1 ms-2">
                  <span>Waiting Approval</span>
                  <h3 class="fs-20 mt-1 mb-0">
                    {{ reqOverview?.waiting }}
                  </h3>
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-items-center"
              >
                <span class="fs-12">Requisition Status Waiting Approval</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-6 col-xl-6 col-sm-6">
          <div
            class="card bg-primary-div bg-opacity-10 border-primary-div border-opacity-10 rounded-3 mb-4 stats-box style-three"
          >
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-19">
                <div class="flex-shrink-0">
                  <i class="material-symbols-outlined fs-40 text-primary-div">
                    edit_square
                  </i>
                </div>
                <div class="flex-grow-1 ms-2">
                  <span>On Process</span>
                  <h3 class="fs-20 mt-1 mb-0">{{ reqOverview?.process }}</h3>
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-items-center"
              >
                <span class="fs-12">Requisition Status On Process</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-6 col-xl-6 col-sm-6">
          <div
            class="card bg-success bg-opacity-10 border-success border-opacity-10 rounded-3 mb-4 stats-box style-three"
          >
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-19">
                <div class="flex-shrink-0">
                  <i class="material-symbols-outlined fs-40 text-success">
                    assignment_turned_in
                  </i>
                </div>
                <div class="flex-grow-1 ms-2">
                  <span>Complete</span>
                  <h3 class="fs-20 mt-1 mb-0">{{ reqOverview?.completed }}</h3>
                </div>
              </div>
              <div
                class="d-flex justify-content-between flex-wrap gap-2 align-items-center"
              >
                <span class="fs-12">Requisition Status Completed</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useDashboardStore } from "@/stores/dashboard/general";
import { defineComponent, onMounted, ref } from "vue";
export default defineComponent({
  name: "ProjectsOverview",
  setup(props, ctx) {
    const dashboardStore = useDashboardStore();
    const reqOverview = ref();

    const loadOverview = async (query: string) => {
      const { success } = await dashboardStore.dispatchRequisitionOverview(
        query
      );

      reqOverview.value = dashboardStore.generalData;
    };

    onMounted(() => {
      loadOverview("");
    });

    return {
      reqOverview,
    };
  },
});
</script>

<style lang="scss" scoped>
.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}
</style>
